import * as React from 'react';
import { IntlService } from './IntlService';
export var IntlContext = React.createContext(new IntlService('en'));
//# sourceMappingURL=IntlContext.js.map